import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { css } from "@emotion/css";
import { GatsbyImage } from "gatsby-plugin-image";
import { default as CTAComponent } from "../cta/cta";

export const TextAndIconsBase = styled.section`
  h5 {
    margin-bottom: 0;
    color: ${theme.colors.white};
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    gap: ${theme.spacing[8]};

    li {
      margin: 0;
      height: 40px;
      width: 40px;
      display: flex;
      justify-content: center;

      ${theme.largerThan.md} {
        height: 60px;
        min-width: 60px;
      }
      ${theme.largerThan.lg} {
        flex-grow: 1;
      }
    }
  }
`;
